// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.addNew {
  border: 1px dashed !important;
  opacity: 0;
  pointer-events: none;
}

.center {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  padding: 0.625em;
}

#myDashboards {
  display: grid;
  grid-template-columns: repeat(auto-fill, 23.5em);
  justify-content: space-between;
  grid-row-gap: 40px;
  margin-bottom: 20px;
}

#dashboard-heading {
  margin-bottom: calc(10 / 14 * 1em);
  margin-top: calc(5 / 14 * 1em);
  font-weight: bold;
  font-size: calc(24 / 14 * 1em);
  line-height: calc(28 / 14 * 1em);
  color: #343a40;
  width: 50%;
}
#dashboard-heading:hover {
  color: #157188;
}

.dashboard-body {
  min-height: 75vh;
}

.dashboard-create-div {
  float: right;
}

.dashboard-item {
  background: #e7e7e7;
  border-radius: calc(8 / 14 * 1em);
  padding: calc(14 / 14 * 1em) calc(20 / 14 * 1em) calc(14 / 14 * 1em) calc(20 / 14 * 1em);
  width: calc(327 / 14 * 1em);
  min-height: calc(330 / 14 * 1em);
  max-height: 500px;
  overflow: hidden;
  font-family: "Poppins";
}
.dashboard-item:hover {
  background: rgba(217, 221, 231, 0.6);
  border: 1px solid #a6a6a6;
  box-sizing: border-box;
  box-shadow: -2px 0px 11px #157188;
}
.dashboard-item:hover .dashboard-icon {
  display: block !important;
}

.dashboard-item_header {
  font-size: calc(14 / 14 * 1em);
  height: calc(28 / 14 * 1em);
  display: flex;
}
.dashboard-item_header > .dashboard-item_tools {
  display: flex;
}

.dashboard-item_title {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: calc(16 / 14 * 1em);
  letter-spacing: -0.02em;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 400px;
  white-space: nowrap;
  overflow: hidden;
  width: 80%;
  color: #1b2559;
}
.dashboard-item_title:hover {
  color: #157188;
}

.db-title-container {
  min-width: 400px;
  display: flex;
  align-items: center;
}

.dashboard-item_footer {
  height: calc(25 / 14 * 1em);
}

.dashboard-icon {
  display: none !important;
  font-size: calc(23 / 14 * 1em) !important;
  margin-left: calc(5 / 14 * 1em);
  color: #168884;
  cursor: pointer;
}
.dashboard-icon:hover {
  color: #157188 !important;
}

.dashboard-item_info {
  width: 100%;
  font-size: calc(12 / 14 * 1em);
  line-height: calc(14 / 14 * 1em);
  letter-spacing: -0.02em;
  color: #afafaf;
  margin-top: calc(10 / 14 * 1em);
  display: flex;
}
.dashboard-item_info > span {
  width: 40%;
}

.dashboard-item_ellipsis {
  width: 60%;
  margin-top: calc(-9 / 14 * 1em);
}

.dashboard-item_image {
  margin-top: calc(5 / 14 * 1em);
  width: 100%;
  height: auto;
  overflow: hidden;
}
.dashboard-item_image > img {
  width: 100%;
  max-height: 100%;
  -o-object-fit: fill;
     object-fit: fill;
  min-height: 280px;
}

.shared-circle {
  height: 24px;
  width: 24px;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  text-align: center;
  background: linear-gradient(0deg, #168884, #168884);
  margin-left: calc(-5 / 14 * 1em);
  font-size: calc(10 / 14 * 1em);
  line-height: calc(12 / 14 * 1em);
  letter-spacing: -0.02em;
}

.shared-count {
  font-weight: bold;
  font-size: calc(12 / 14 * 1em);
  line-height: calc(14 / 14 * 1em);
  letter-spacing: -0.02em;
  color: #102038;
  margin-left: calc(5 / 14 * 1em);
  margin-top: calc(10 / 14 * 1em);
}

#jh-create-dashboard {
  margin-right: calc(45 / 14 * 1em);
}

.dashboard-item_ellipsis {
  cursor: pointer;
}

.wc-container {
  flex: 1;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 2px 12px rgba(37, 51, 66, 0.15) !important;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  background-color: #1b1d20;
}

.react-grid-layout {
  margin-left: -15px;
  margin-right: -15px;
}

.react-grid-item.react-grid-placeholder {
  background-color: #f3f4f6 !important;
  border: none !important;
  box-shadow: none !important;
}

.react-grid-item {
  overflow: visible !important;
  background: #ffffff;
  border-radius: calc(8 / 14 * 1em);
  border: 0;
  padding: 0 !important;
}
.react-grid-item .react-resizable-handle {
  opacity: 0;
  pointer-events: none;
}
.react-grid-item .react-resizable-handle:after {
  content: none;
}
.react-grid-item .widget-container {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 6px;
  background: none;
}
.react-grid-item .widget-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #dcdcdc;
  padding: calc(6 / 14 * 1em);
  padding-left: calc(12 / 14 * 1em);
  background-color: #fff;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  background-color: #dbdbdb;
}
.react-grid-item .widget-header .widget-name {
  font-weight: 500;
  font-size: 16px;
  color: black;
}
.react-grid-item .widget-header .v-type {
  font-weight: normal;
  font-size: calc(14 / 14 * 1em);
  line-height: 16px;
  color: rgba(0, 0, 0, 0.4);
  margin-top: 2px;
}
.react-grid-item .widget-header .widget-toolbar {
  display: none;
  margin-right: 5px;
}
.react-grid-item .widget-header .widget-toolbar span {
  height: calc(18 / 14 * 1em);
  width: calc(18 / 14 * 1em);
  margin-right: calc(10 / 14 * 1em);
}
.react-grid-item .widget-header .widget-toolbar span:hover {
  cursor: pointer;
}
.react-grid-item .widget-header .widget-toolbar span:last-child {
  margin-right: 0;
}
.react-grid-item .widget-header .widget-toolbar span.drag {
  height: calc(26 / 14 * 1em);
  width: calc(26 / 14 * 1em);
  cursor: move;
}

svg[data-icon=pen-to-square] path {
  transition: fill 0.2s ease; /* smooth change */
}

svg[data-icon=pen-to-square]:hover path {
  fill: #157188; /* hover color */
}

svg[data-icon=pen-to-square] path {
  transition: fill 0.2s ease; /* smooth change */
}

svg[data-icon=pen-to-square]:hover path {
  fill: #157188; /* hover color */
}

.edit-mode {
  background-image: url("content/images/edit_background.png");
  background-repeat: repeat;
  height: 100%;
  padding-left: 1.375em;
  padding-right: 1.375em;
  min-height: 100vh;
  min-width: 100%;
  overflow: hidden;
}
.edit-mode .react-grid-item:not(.addNew) {
  box-sizing: border-box;
  box-shadow: 0px 2px 12px rgba(37, 51, 66, 0.15);
  border-radius: 8px;
}
.edit-mode .react-grid-item:not(.addNew) > div > .wc-container {
  box-shadow: none !important;
}
.edit-mode .react-grid-item:not(.addNew) > div > .widget-header {
  background-color: #dbdbdb;
}
.edit-mode .react-grid-item:not(.addNew):hover {
  opacity: 1;
  background: none !important;
  border: 3px solid #168884;
  box-sizing: border-box;
  box-shadow: 0px calc(2 / 14 * 1em) calc(12 / 14 * 1em) rgba(37, 51, 66, 0.15);
  border-radius: calc(8 / 14 * 1em);
}
.edit-mode .react-grid-item:not(.addNew):hover .widget-toolbar {
  display: block;
}
.edit-mode .react-grid-item:not(.addNew):hover .widget-header {
  background-color: #fff;
}
.edit-mode .react-grid-item:not(.addNew):hover .react-resizable-handle {
  opacity: 1;
  pointer-events: visible;
}
.edit-mode .react-grid-item:not(.addNew):focus {
  opacity: 1;
  background: #ffffff;
  border: calc(3 / 14 * 1em) solid #168884;
  box-sizing: border-box;
  box-shadow: 0px calc(2 / 14 * 1em) calc(12 / 14 * 1em) rgba(37, 51, 66, 0.15);
  border-radius: calc(8 / 14 * 1em);
}
.edit-mode .react-grid-item:not(.addNew):focus .react-resizable-handle {
  opacity: 1;
  pointer-events: visible;
}
.edit-mode .react-grid-item:not(.addNew) .react-resizable-handle {
  width: calc(19 / 14 * 1em);
  height: calc(19 / 14 * 1em);
  border: calc(2 / 14 * 1em) solid #168884;
  background: #ffffff;
  box-sizing: border-box;
  margin: calc(-10 / 14 * 1em);
}
.edit-mode .react-grid-item:not(.addNew) .react-resizable-handle:after {
  content: none;
}
.edit-mode .addNew {
  opacity: 1;
  pointer-events: visible;
  display: block;
}

.db-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: calc(38 / 14 * 1em);
  margin-top: calc(38 / 14 * 1em);
  background: #ffffff !important;
  border-radius: 8px;
  padding: calc(15 / 14 * 1em);
  box-shadow: 0px 2px 12px rgba(37, 51, 66, 0.15);
  border-radius: 8px;
  padding: 10px;
}
.db-toolbar .db-edit-actions {
  display: flex;
  align-items: center;
  border-left: 1px solid #a0a0a0;
}
.db-toolbar .db-edit-actions button {
  margin-left: calc(41 / 14 * 1em);
}
.db-toolbar .db-edit-actions button :first-child {
  margin-left: 0;
}
.db-toolbar .db-view-actions {
  display: flex;
  align-items: center;
}
.db-toolbar .db-view-actions button {
  margin-left: calc(15 / 14 * 1em);
}
.db-toolbar .db-view-actions button :first-child {
  margin-left: 0;
}

.box {
  float: left;
  height: 40px;
  width: 40px;
  clear: both;
  background: #efefef;
  border-radius: 4px;
  margin-left: 10px;
  align-items: center;
  display: flex;
  justify-content: center;
  cursor: pointer;
  color: #168884;
}
.box.box-icon {
  opacity: 0.8;
}
.box:hover {
  background: #168884;
  color: #ffffff;
}

.db-info {
  color: #343a40;
  display: flex;
  align-items: center;
}
.db-info svg {
  height: calc(18 / 14 * 1em);
  margin-left: calc(18 / 14 * 1em);
  margin-right: calc(18 / 14 * 1em);
}
.db-info svg.db-title-save {
  margin-left: calc(16 / 14 * 1em) !important;
  margin-right: calc(6 / 14 * 1em) !important;
  color: #345587;
}
.db-info svg.db-title-reset {
  margin-left: calc(6 / 14 * 1em) !important;
  margin-right: calc(6 / 14 * 1em) !important;
  color: #343a40;
}
.db-info .db-group {
  font-weight: bold;
  font-size: calc(24 / 14 * 1em);
  line-height: calc(28 / 14 * 1em);
  color: #168884;
}
.db-info .db-group:hover {
  color: #157188;
}
.db-info .db-title {
  font-style: italic;
  font-weight: 500;
  font-size: calc(20 / 14 * 1em);
  line-height: calc(23 / 14 * 1em);
  text-decoration-line: underline;
}

/* share treeview styles */
.rct-text {
  padding: 5px;
}

.rct-title {
  font-family: "Poppins";
  font-size: 0.9em;
  color: #5c6c99;
}

.tenant > span.rct-text {
  font-weight: bold;
}

.rct-node-icon > i {
  font-size: 1em;
  color: #909ab8;
}

.checkboxTreeModal {
  height: 350px;
  overflow: scroll;
}

.fa-check-square:before {
  color: #168884;
}

i.fa.fa-caret-down {
  color: #168884;
  font-size: 1.6em;
}

i.fa.fa-caret-right {
  color: #168884;
  font-size: 1.6em;
}

.dropdown .show > .timeWidgetDropDown {
  background-color: #ffffff !important;
  color: #000000 !important;
}

.timeWidgetDropDown.btn-secondary {
  background-color: #ffffff;
  color: #000000;
  width: calc(180 / 14 * 1em);
  font-size: 14px;
  box-shadow: 0px 2px 12px rgba(37, 51, 66, 0.15) !important;
  justify-content: space-between;
}
.timeWidgetDropDown.btn-secondary > .timeWidgetDropDown_text {
  min-width: 100px;
  text-align: left;
}
.timeWidgetDropDown.btn-secondary > .timeWidgetDropDown_icon {
  margin-right: -10px;
}
.timeWidgetDropDown.btn-secondary:hover, .timeWidgetDropDown.btn-secondary:focus, .timeWidgetDropDown.btn-secondary:active {
  background-color: #ffffff !important;
  color: #000000 !important;
  background: none !important;
}

.timeWidgetMenuItem {
  padding: 0px !important;
}
.timeWidgetMenuItem > .dropdown-item.selected {
  background-color: #168884 !important;
  color: #ffffff !important;
}
.timeWidgetMenuItem > .dropdown-item {
  margin: 0px !important;
  padding-left: 13px;
  font-size: 14px;
  height: 40px;
}
.timeWidgetMenuItem > .dropdown-item:focus {
  background-color: #168884 !important;
  color: #ffffff !important;
}

.customPair {
  min-width: 50px;
  margin-right: 5px;
  display: flex;
}
.customPair > .field {
  font-weight: bold;
}

.custom-tooltip {
  border: 1px solid #9ca3af;
  background: #ffffff;
  color: #8392ab;
  padding: 5px;
  display: block;
}

.widgetModal > .modal-content {
  min-width: 750px;
  min-height: 750px;
  max-height: 750px;
  overflow-y: auto;
}

.widgetModalBody .row + .row {
  margin-top: 20px; /* Adjust spacing as needed */
}

.token-input-container {
  height: auto !important;
}

.dropdown-item.active,
.dropdown-item:active {
  background-color: #168884 !important;
}

.filter-pill {
  font-size: 12px;
  font-weight: 500;
  border: none !important;
}

.drag:hover path,
.drag:hover circle,
.drag:hover rect {
  fill: #157188 !important; /* hover color */
}

.pencil:hover path,
.pencil:hover circle,
.pencil:hover rect {
  fill: #157188 !important; /* hover color */
}

.bin:hover path,
.bin:hover circle,
.bin:hover rect {
  fill: #157188 !important; /* hover color */
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/app/entities/dashboard/styles/dashboard.scss"],"names":[],"mappings":"AAyEA;EACE,6BAAA;EACA,UAAA;EACA,oBAAA;AAxEF;;AA2EA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,gBAAA;AAxEF;;AA0EA;EACE,aAAA;EACA,gDAAA;EACA,8BAAA;EACA,kBAAA;EACA,mBAAA;AAvEF;;AA0EA;EACE,kCAAA;EACA,8BAAA;EACA,iBAAA;EACA,8BAAA;EACA,gCAAA;EACA,cAhEK;EAiEL,UAAA;AAvEF;AAwEE;EACE,cAtCgB;AAhCpB;;AA0EA;EACE,gBAAA;AAvEF;;AA0EA;EACE,YAAA;AAvEF;;AA0EA;EACE,mBAAA;EACA,iCAAA;EACA,wFAAA;EACA,2BAAA;EACA,gCAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBApE8B;AAHhC;AAwEE;EACE,oCAAA;EACA,yBAAA;EACA,sBAAA;EACA,iCAAA;AAtEJ;AAuEI;EACE,yBAAA;AArEN;;AA0EA;EACE,8BAAA;EACA,2BAAA;EACA,aAAA;AAvEF;AAwEE;EACE,aAAA;AAtEJ;;AA0EA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gCAAA;EACA,uBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,UAAA;EACA,cApHU;AA6CZ;AAwEE;EACE,cA7FgB;AAuBpB;;AAyEA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;AAtEF;;AAwEA;EACE,2BAAA;AArEF;;AAuEA;EACE,wBAAA;EACA,yCAAA;EACA,+BAAA;EACA,cAhKc;EAiKd,eAAA;AApEF;AAqEE;EACE,yBAAA;AAnEJ;;AAuEA;EACE,WAAA;EACA,8BAAA;EACA,gCAAA;EACA,uBAAA;EACA,cAAA;EACA,+BAAA;EACA,aAAA;AApEF;AAqEE;EACE,UAAA;AAnEJ;;AAuEA;EACE,UAAA;EACA,+BAAA;AApEF;;AAuEA;EACE,8BAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AApEF;AAqEE;EACE,WAAA;EACA,gBAAA;EACA,mBAAA;KAAA,gBAAA;EACA,iBAAA;AAnEJ;;AAuEA;EACE,YAAA;EACA,WAAA;EACA,cAnMY;EAoMZ,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mDAAA;EACA,gCAAA;EACA,8BAAA;EACA,gCAAA;EACA,uBAAA;AApEF;;AAuEA;EACE,iBAAA;EACA,8BAAA;EACA,gCAAA;EACA,uBAAA;EACA,cAjNa;EAkNb,+BAAA;EACA,+BAAA;AApEF;;AAuEA;EACE,iCAAA;AApEF;;AAuEA;EACE,eAAA;AApEF;;AAuEA;EACE,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,0DAAA;EACA,8BAAA;EACA,+BAAA;EACA,yBAAA;AApEF;;AAwEA;EACE,kBAAA;EACA,mBAAA;AArEF;;AAwEA;EACE,oCAAA;EACA,uBAAA;EACA,2BAAA;AArEF;;AAwEA;EACE,4BAAA;EACA,mBA9PY;EA+PZ,iCAAA;EACA,SAAA;EACA,qBAAA;AArEF;AAuEE;EACE,UAAA;EACA,oBAAA;AArEJ;AAsEI;EACE,aAAA;AApEN;AAwEE;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EAEA,kBAAA;EACA,gBAAA;AAvEJ;AA0EE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gCAAA;EACA,2BAAA;EACA,iCAAA;EACA,sBAhQY;EAiQZ,2BAAA;EACA,4BAAA;EACA,yBAAA;AAxEJ;AA0EI;EACE,gBAAA;EACA,eAAA;EACA,YAAA;AAxEN;AA2EI;EACE,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,yBAAA;EACA,eAAA;AAzEN;AA4EI;EACE,aAAA;EACA,iBAAA;AA1EN;AA2EM;EASE,2BAAA;EACA,0BAAA;EACA,iCAAA;AAjFR;AAuEQ;EACE,eAAA;AArEV;AAwEQ;EACE,eAAA;AAtEV;AA6EQ;EACE,2BAAA;EACA,0BAAA;EACA,YAAA;AA3EV;;AAiFA;EACE,0BAAA,EAAA,kBAAA;AA9EF;;AAiFA;EACE,aAAA,EAAA,gBAAA;AA9EF;;AAiFA;EACE,0BAAA,EAAA,kBAAA;AA9EF;;AAiFA;EACE,aAAA,EAAA,gBAAA;AA9EF;;AAiFA;EACE,2DAAA;EACA,yBAAA;EACA,YAAA;EACA,qBAAA;EACA,sBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;AA9EF;AAgFE;EAEE,sBAAA;EACA,+CAAA;EACA,kBAAA;AA/EJ;AAiFI;EACE,2BAAA;AA/EN;AAkFI;EACE,yBAAA;AAhFN;AAmFI;EACE,UAAA;EACA,2BAAA;EACA,yBAAA;EACA,sBAAA;EACA,6EAAA;EACA,iCAAA;AAjFN;AAmFM;EACE,cAAA;AAjFR;AAoFM;EACE,sBAjWQ;AA+QhB;AAoFM;EACE,UAAA;EACA,uBAAA;AAlFR;AAsFI;EACE,UAAA;EACA,mBAvYQ;EAwYR,wCAAA;EACA,sBAAA;EACA,6EAAA;EACA,iCAAA;AApFN;AAsFM;EACE,UAAA;EACA,uBAAA;AApFR;AAwFI;EACE,0BAAA;EACA,2BAAA;EACA,wCAAA;EACA,mBAAA;EACA,sBAAA;EACA,4BAAA;AAtFN;AAwFM;EACE,aAAA;AAtFR;AA2FE;EACE,UAAA;EACA,uBAAA;EACA,cAAA;AAzFJ;;AA6FA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kCAAA;EACA,+BAAA;EACA,8BAAA;EACA,kBAAA;EACA,4BAAA;EACA,+CAAA;EACA,kBAAA;EACA,aAAA;AA1FF;AA4FE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AA1FJ;AA2FI;EAIE,gCAAA;AA5FN;AAyFM;EACE,cAAA;AAvFR;AA6FE;EACE,aAAA;EACA,mBAAA;AA3FJ;AA4FI;EAIE,gCAAA;AA7FN;AA0FM;EACE,cAAA;AAxFR;;AA+FA;EACE,WAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EACA,cA/dc;AAmYhB;AA6FE;EACE,YAAA;AA3FJ;AA6FE;EACE,mBApeY;EAqeZ,cA/dU;AAoYd;;AA8FA;EACE,cAldK;EAmdL,aAAA;EACA,mBAAA;AA3FF;AA6FE;EACE,2BAAA;EACA,gCAAA;EACA,iCAAA;AA3FJ;AA6FI;EACE,2CAAA;EACA,2CAAA;EACA,cAlcc;AAuWpB;AA8FI;EACE,0CAAA;EACA,2CAAA;EACA,cArcgB;AAyWtB;AAgGE;EACE,iBAAA;EACA,8BAAA;EACA,gCAAA;EACA,cAngBY;AAqahB;AA+FI;EACE,cAjdc;AAoXpB;AAiGE;EACE,kBAAA;EACA,gBAAA;EACA,8BAAA;EACA,gCAAA;EACA,+BAAA;AA/FJ;;AAmGA,0BAAA;AACA;EACE,YAAA;AAhGF;;AAkGA;EACE,sBA7e8B;EA8e9B,gBAAA;EACA,cA3foB;AA4ZtB;;AAkGA;EACE,iBAAA;AA/FF;;AAkGA;EACE,cAAA;EACA,cAAA;AA/FF;;AAiGA;EACE,aAAA;EACA,gBAAA;AA9FF;;AAiGA;EACE,cA1iBc;AA4chB;;AAiGA;EACE,cA9iBc;EA+iBd,gBAAA;AA9FF;;AAiGA;EACE,cAnjBc;EAojBd,gBAAA;AA9FF;;AAiGA;EACE,oCAAA;EACA,yBAAA;AA9FF;;AAiGA;EACE,yBAvjBY;EAwjBZ,cAvjBY;EAwjBZ,2BAAA;EACA,eAAA;EACA,0DAAA;EACA,8BAAA;AA9FF;AA+FE;EACE,gBAAA;EACA,gBAAA;AA7FJ;AAgGE;EACE,mBAAA;AA9FJ;AAiGE;EAGE,oCAAA;EACA,yBAAA;EACA,2BAAA;AAjGJ;;AAoGA;EACE,uBAAA;AAjGF;AAkGE;EACE,oCAAA;EACA,yBAAA;AAhGJ;AAkGE;EACE,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;AAhGJ;AAkGI;EACE,oCAAA;EACA,yBAAA;AAhGN;;AAqGA;EACE,eAAA;EACA,iBAAA;EACA,aAAA;AAlGF;AAmGE;EACE,iBAAA;AAjGJ;;AAoGA;EACE,yBAAA;EACA,mBA3mBY;EA4mBZ,cA1mBc;EA2mBd,YAAA;EACA,cAAA;AAjGF;;AAoGA;EACE,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;AAjGF;;AAoGA;EACE,gBAAA,EAAA,6BAAA;AAjGF;;AAoGA;EACE,uBAAA;AAjGF;;AAoGA;;EAEE,oCAAA;AAjGF;;AAoGA;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;AAjGF;;AAoGA;;;EAGE,wBAAA,EAAA,gBAAA;AAjGF;;AAoGA;;;EAGE,wBAAA,EAAA,gBAAA;AAjGF;;AAoGA;;;EAGE,wBAAA,EAAA,gBAAA;AAjGF","sourcesContent":["// Variable overrides\n$browser-context: 14; // Default\n\n@function em($pixels, $context: $browser-context) {\n  @return calc(#{$pixels} / #{$context} * 1em);\n}\n\n@mixin transitions($transitions...) {\n  -webkit-transition: $transitions;\n  -o-transition: $transitions;\n  transition: $transitions;\n}\n\n$primary-color: #168884;\n$primary-color_gradient: linear-gradient(180deg, #5babf7 0%, #1860a3 100%);\n$secondary-color_mild: #f2ae70;\n$secondary-color: #e05a26;\n$secondary-color_font: #5a5b5b;\n$secondary-color_gradient: linear-gradient(180deg, #fb9b42 0%, #ca5412 100%);\n$white-color: #ffffff;\n$black-color: #000000;\n$content-color: #8392ab;\n$light-gray: #f7f7f7;\n$gray-shade-1: #102038;\n$gray-shade-2: #374151;\n$gray-shade-3: #4b5563;\n$gray-shade-4: #6b7280;\n$gray-shade-5: #9ca3af;\n$gray-shade-6: #d1d5db;\n$gray-shade-7: #f3f4f6;\n$border-color: #eeebeb;\n$success-color: #76ca66;\n$info-color: rgb(17, 106, 204, 0.5);\n$error-color: rgb(186, 0, 0, 0.5);\n$caution-color: rgb(251, 199, 86, 0.5);\n$dark-gray: #385453;\n$gray: #343a40;\n$light-gray: #919293;\n$lighter-gray: #acb9c8;\n$lightest-gray: #d1d5db;\n$dark-blue: #1b2559;\n$divider-color: #e4e4e4;\n$dull-blue: #868e96;\n$side-nav-icon-color: #5c6c99;\n$surface-color: #f8f8f8;\n$form-field-error: BA0000;\n$big-number-bg: rgba(255, 222, 192, 0.3);\n$widget-header: #fff;\n\n$icon-color-active: #1890ff;\n$icon-color-active_dull: #116acc;\n\n$alert-warning: rgba(235, 173, 52, 0.24);\n$alert-warning: rgba(235, 173, 52, 0.24);\n$primary-font-family-regular: 'Inter';\n$secondary-font-family-regular: 'Poppins';\n\n$header-color: #fff;\n$header-color-secondary: #bbb;\n$header-color-hover: darken($header-color, 20%);\n\n$all-right-reserved-color: #8593a4;\n$label-color: #182233;\n\n$btn-primary-color: #345587;\n$btn-primary-hover: #157188;\n$btn-primary-pressed: #157188;\n$btn-secondary-color: #343a40;\n$btn-secondary-hover: linear-gradient(0deg, rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0.3)), #343a40;\n$btn-secondary-pressed: linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), #343a40;\n$input_error: #e31e18;\n$menu-hover: rgba(52, 85, 135, 0.1);\n\n.addNew {\n  border: 1px dashed !important;\n  opacity: 0;\n  pointer-events: none;\n}\n\n.center {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  padding: 0.625em;\n}\n#myDashboards {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, 23.5em);\n  justify-content: space-between;\n  grid-row-gap: 40px;\n  margin-bottom: 20px;\n}\n\n#dashboard-heading {\n  margin-bottom: em(10);\n  margin-top: em(5);\n  font-weight: bold;\n  font-size: em(24);\n  line-height: em(28);\n  color: $gray;\n  width: 50%;\n  &:hover {\n    color: $btn-primary-hover;\n  }\n}\n\n.dashboard-body {\n  min-height: 75vh;\n}\n\n.dashboard-create-div {\n  float: right;\n}\n\n.dashboard-item {\n  background: #e7e7e7;\n  border-radius: em(8);\n  padding: em(14) em(20) em(14) em(20);\n  width: em(327, 14);\n  min-height: em(330, 14);\n  max-height: 500px;\n  overflow: hidden;\n  font-family: $secondary-font-family-regular;\n  &:hover {\n    background: rgba(217, 221, 231, 0.6);\n    border: 1px solid #a6a6a6;\n    box-sizing: border-box;\n    box-shadow: -2px 0px 11px #157188;\n    .dashboard-icon {\n      display: block !important;\n    }\n  }\n}\n\n.dashboard-item_header {\n  font-size: em(14);\n  height: em(28);\n  display: flex;\n  & > .dashboard-item_tools {\n    display: flex;\n  }\n}\n\n.dashboard-item_title {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: em(16);\n  letter-spacing: -0.02em;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 400px;\n  white-space: nowrap;\n  overflow: hidden;\n  width: 80%;\n  color: $dark-blue;\n  &:hover {\n    color: $btn-primary-hover;\n  }\n}\n.db-title-container {\n  min-width: 400px;\n  display: flex;\n  align-items: center;\n}\n.dashboard-item_footer {\n  height: em(25);\n}\n.dashboard-icon {\n  display: none !important;\n  font-size: em(23) !important;\n  margin-left: em(5);\n  color: $primary-color;\n  cursor: pointer;\n  &:hover {\n    color: $btn-primary-hover !important;\n  }\n}\n\n.dashboard-item_info {\n  width: 100%;\n  font-size: em(12);\n  line-height: em(14);\n  letter-spacing: -0.02em;\n  color: #afafaf;\n  margin-top: em(10);\n  display: flex;\n  & > span {\n    width: 40%;\n  }\n}\n\n.dashboard-item_ellipsis {\n  width: 60%;\n  margin-top: em(-9);\n}\n\n.dashboard-item_image {\n  margin-top: em(5);\n  width: 100%;\n  height: auto;\n  overflow: hidden;\n  & > img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: fill;\n    min-height: 280px;\n  }\n}\n\n.shared-circle {\n  height: 24px;\n  width: 24px;\n  color: $white-color;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 100%;\n  text-align: center;\n  background: linear-gradient(0deg, $primary-color, $primary-color);\n  margin-left: em(-5);\n  font-size: em(10);\n  line-height: em(12);\n  letter-spacing: -0.02em;\n}\n\n.shared-count {\n  font-weight: bold;\n  font-size: em(12);\n  line-height: em(14);\n  letter-spacing: -0.02em;\n  color: $gray-shade-1;\n  margin-left: em(5);\n  margin-top: em(10);\n}\n\n#jh-create-dashboard {\n  margin-right: em(45);\n}\n\n.dashboard-item_ellipsis {\n  cursor: pointer;\n}\n\n.wc-container {\n  flex: 1;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0px 2px 12px rgba(37, 51, 66, 0.15) !important;\n  border-bottom-left-radius: 8px;\n  border-bottom-right-radius: 8px;\n  background-color: #1b1d20;\n  // overflow: scroll;\n  // background-color: rgb(28, 28, 33);\n}\n.react-grid-layout {\n  margin-left: -15px;\n  margin-right: -15px;\n}\n\n.react-grid-item.react-grid-placeholder {\n  background-color: $gray-shade-7 !important;\n  border: none !important;\n  box-shadow: none !important;\n}\n\n.react-grid-item {\n  overflow: visible !important;\n  background: $white-color;\n  border-radius: em(8);\n  border: 0;\n  padding: 0 !important;\n\n  .react-resizable-handle {\n    opacity: 0;\n    pointer-events: none;\n    &:after {\n      content: none;\n    }\n  }\n\n  .widget-container {\n    height: 100%;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    //border: 1px solid #dbdbdb;\n    border-radius: 6px;\n    background: none;\n  }\n\n  .widget-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-bottom: 1px solid #dcdcdc;\n    padding: em(6);\n    padding-left: em(12);\n    background-color: $widget-header;\n    border-top-left-radius: 8px;\n    border-top-right-radius: 8px;\n    background-color: #dbdbdb;\n\n    .widget-name {\n      font-weight: 500;\n      font-size: 16px;\n      color: black;\n    }\n\n    .v-type {\n      font-weight: normal;\n      font-size: em(14);\n      line-height: 16px;\n      color: rgba(0, 0, 0, 0.4);\n      margin-top: 2px;\n    }\n\n    .widget-toolbar {\n      display: none;\n      margin-right: 5px;\n      span {\n        &:hover {\n          cursor: pointer;\n        }\n\n        &:last-child {\n          margin-right: 0;\n        }\n\n        height: em(18);\n        width: em(18);\n        margin-right: em(10);\n\n        &.drag {\n          height: em(26);\n          width: em(26);\n          cursor: move;\n        }\n      }\n    }\n  }\n}\nsvg[data-icon='pen-to-square'] path {\n  transition: fill 0.2s ease; /* smooth change */\n}\n\nsvg[data-icon='pen-to-square']:hover path {\n  fill: #157188; /* hover color */\n}\n\nsvg[data-icon='pen-to-square'] path {\n  transition: fill 0.2s ease; /* smooth change */\n}\n\nsvg[data-icon='pen-to-square']:hover path {\n  fill: #157188; /* hover color */\n}\n\n.edit-mode {\n  background-image: url('content/images/edit_background.png');\n  background-repeat: repeat;\n  height: 100%;\n  padding-left: 1.375em;\n  padding-right: 1.375em;\n  min-height: 100vh;\n  min-width: 100%;\n  overflow: hidden;\n\n  .react-grid-item:not(.addNew) {\n    //border: 1px solid #000000;\n    box-sizing: border-box;\n    box-shadow: 0px 2px 12px rgba(37, 51, 66, 0.15);\n    border-radius: 8px;\n\n    & > div > .wc-container {\n      box-shadow: none !important;\n    }\n\n    & > div > .widget-header {\n      background-color: #dbdbdb;\n    }\n\n    &:hover {\n      opacity: 1;\n      background: none !important;\n      border: 3px solid $primary-color;\n      box-sizing: border-box;\n      box-shadow: 0px em(2) em(12) rgba(37, 51, 66, 0.15);\n      border-radius: em(8);\n\n      .widget-toolbar {\n        display: block;\n      }\n\n      .widget-header {\n        background-color: $widget-header;\n      }\n      .react-resizable-handle {\n        opacity: 1;\n        pointer-events: visible;\n      }\n    }\n\n    &:focus {\n      opacity: 1;\n      background: $white-color;\n      border: em(3) solid $primary-color;\n      box-sizing: border-box;\n      box-shadow: 0px em(2) em(12) rgba(37, 51, 66, 0.15);\n      border-radius: em(8);\n\n      .react-resizable-handle {\n        opacity: 1;\n        pointer-events: visible;\n      }\n    }\n\n    .react-resizable-handle {\n      width: em(19);\n      height: em(19);\n      border: em(2) solid $primary-color;\n      background: #ffffff;\n      box-sizing: border-box;\n      margin: em(-10);\n\n      &:after {\n        content: none;\n      }\n    }\n  }\n\n  .addNew {\n    opacity: 1;\n    pointer-events: visible;\n    display: block;\n  }\n}\n\n.db-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: em(38);\n  margin-top: em(38);\n  background: $white-color !important;\n  border-radius: 8px;\n  padding: em(15);\n  box-shadow: 0px 2px 12px rgba(37, 51, 66, 0.15);\n  border-radius: 8px;\n  padding: 10px;\n\n  .db-edit-actions {\n    display: flex;\n    align-items: center;\n    border-left: 1px solid #a0a0a0;\n    button {\n      :first-child {\n        margin-left: 0;\n      }\n      margin-left: em(41);\n    }\n  }\n\n  .db-view-actions {\n    display: flex;\n    align-items: center;\n    button {\n      :first-child {\n        margin-left: 0;\n      }\n      margin-left: em(15);\n    }\n  }\n}\n\n.box {\n  float: left;\n  height: 40px;\n  width: 40px;\n  clear: both;\n  background: #efefef;\n  border-radius: 4px;\n  margin-left: 10px;\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  cursor: pointer;\n  color: $primary-color;\n  &.box-icon {\n    opacity: 0.8;\n  }\n  &:hover {\n    background: $primary-color;\n    color: $white-color;\n  }\n}\n.db-info {\n  color: $gray;\n  display: flex;\n  align-items: center;\n\n  svg {\n    height: em(18);\n    margin-left: em(18);\n    margin-right: em(18);\n\n    &.db-title-save {\n      margin-left: em(16) !important;\n      margin-right: em(6) !important;\n      color: $btn-primary-color;\n    }\n\n    &.db-title-reset {\n      margin-left: em(6) !important;\n      margin-right: em(6) !important;\n      color: $btn-secondary-color;\n    }\n  }\n\n  .db-group {\n    font-weight: bold;\n    font-size: em(24);\n    line-height: em(28);\n    color: $primary-color;\n    &:hover {\n      color: $btn-primary-hover;\n    }\n  }\n\n  .db-title {\n    font-style: italic;\n    font-weight: 500;\n    font-size: em(20);\n    line-height: em(23);\n    text-decoration-line: underline;\n  }\n}\n\n/* share treeview styles */\n.rct-text {\n  padding: 5px;\n}\n.rct-title {\n  font-family: $secondary-font-family-regular;\n  font-size: 0.9em;\n  color: $side-nav-icon-color;\n}\n\n.tenant > span.rct-text {\n  font-weight: bold;\n}\n\n.rct-node-icon > i {\n  font-size: 1em;\n  color: #909ab8;\n}\n.checkboxTreeModal {\n  height: 350px;\n  overflow: scroll;\n}\n\n.fa-check-square:before {\n  color: $primary-color;\n}\n\ni.fa.fa-caret-down {\n  color: $primary-color;\n  font-size: 1.6em;\n}\n\ni.fa.fa-caret-right {\n  color: $primary-color;\n  font-size: 1.6em;\n}\n\n.dropdown .show > .timeWidgetDropDown {\n  background-color: $white-color !important;\n  color: $black-color !important;\n}\n\n.timeWidgetDropDown.btn-secondary {\n  background-color: $white-color;\n  color: $black-color;\n  width: em(180);\n  font-size: 14px;\n  box-shadow: 0px 2px 12px rgba(37, 51, 66, 0.15) !important;\n  justify-content: space-between;\n  & > .timeWidgetDropDown_text {\n    min-width: 100px;\n    text-align: left;\n  }\n\n  & > .timeWidgetDropDown_icon {\n    margin-right: -10px;\n  }\n\n  &:hover,\n  &:focus,\n  &:active {\n    background-color: $white-color !important;\n    color: $black-color !important;\n    background: none !important;\n  }\n}\n.timeWidgetMenuItem {\n  padding: 0px !important;\n  & > .dropdown-item.selected {\n    background-color: $primary-color !important;\n    color: $white-color !important;\n  }\n  & > .dropdown-item {\n    margin: 0px !important;\n    padding-left: 13px;\n    font-size: 14px;\n    height: 40px;\n\n    &:focus {\n      background-color: $primary-color !important;\n      color: $white-color !important;\n    }\n  }\n}\n\n.customPair {\n  min-width: 50px;\n  margin-right: 5px;\n  display: flex;\n  & > .field {\n    font-weight: bold;\n  }\n}\n.custom-tooltip {\n  border: 1px solid $gray-shade-5;\n  background: $white-color;\n  color: $content-color;\n  padding: 5px;\n  display: block;\n}\n\n.widgetModal > .modal-content {\n  min-width: 750px;\n  min-height: 750px;\n  max-height: 750px;\n  overflow-y: auto;\n}\n\n.widgetModalBody .row + .row {\n  margin-top: 20px; /* Adjust spacing as needed */\n}\n\n.token-input-container {\n  height: auto !important;\n}\n\n.dropdown-item.active,\n.dropdown-item:active {\n  background-color: $primary-color !important;\n}\n\n.filter-pill {\n  font-size: 12px;\n  font-weight: 500;\n  border: none !important;\n}\n\n.drag:hover path,\n.drag:hover circle,\n.drag:hover rect {\n  fill: $btn-primary-hover !important; /* hover color */\n}\n\n.pencil:hover path,\n.pencil:hover circle,\n.pencil:hover rect {\n  fill: $btn-primary-hover !important; /* hover color */\n}\n\n.bin:hover path,\n.bin:hover circle,\n.bin:hover rect {\n  fill: $btn-primary-hover !important; /* hover color */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
